import React, { useState } from "react";
import { Box, TextField, Button, Typography, Grid2, InputAdornment , IconButton } from "@mui/material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import LogoIcon from "../../assets/images/LogoIcon.svg";
import LogoText from "../../assets/images/LogoText.svg";
import mail from "../../assets/images/email.svg";
import edit from "../../assets/images/edit.svg";
import passwordimg from "../../assets/images/passwordimg.svg";
import rightArrow from "../../assets/images/right.svg";
import fullName from "../../assets/images/full-name.svg";
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../utils/Snackbars";
import useRequestsWOAccessToken from "../../utils/useRequestsWOAccessToken";
import { useDispatch } from "react-redux";
import {
  loadingToggleAction,
  loginAction,
} from "../../store/actions/AuthActions";

const VerifyPhone = () => {
  const dispatch = useDispatch();
  
  const ChangePhone = () => {
    const params = location.search ? location.search : "";
    navigate(`/change-phone${params}`,{
        state:{
            // email:location.state?.email || "",
            phone:location.state?.phone || "",
            // variant: "success",
            // message: "update your email",
        }
    })
  };

  const navigate = useNavigate();
  const location = useLocation();
  const phoneFromState = location.state?.phone || ""; // Get the phone passed from Login page
  // Strip +91 prefix if present to show only 10 digits
  const phone = phoneFromState.startsWith('+91') ? phoneFromState.substring(3) : phoneFromState;
  const { postRequestWOAccessToken } = useRequestsWOAccessToken();
  // const [formData, setFormData] = useState({
  //     fullName:" ",
  //     email:"",
  // });
  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  // Function to get redirect path
  const getRedirectPath = () => {
    // Priority 1: Check localStorage
    let redirectPath = localStorage.getItem("redirectAfterLogin");
    
    // Priority 2: Check location state
    if (redirectPath) {
      localStorage.removeItem("redirectAfterLogin"); // Clean up after reading
    }
    
    // Priority 3: Check URL parameters
    if (!redirectPath) {
      const urlParams = new URLSearchParams(location.search);
      const redirectTo = urlParams.get("redirect");
      const eventId = urlParams.get("e_id");
      const dayPass = urlParams.get("day_pass");

      if (redirectTo && eventId) {
        if (redirectTo === "book-ticket") {
          redirectPath = `/dashboard/events-details/book-ticket/${eventId}`;
          if (dayPass) {
            redirectPath += `?day_pass=${dayPass}`;
          }
        } else if (redirectTo === "resell-market") {
          redirectPath = `/resell-market/ticket-list/${eventId}`;
        }
      }
    }

    // Default to dashboard if no redirect path found
    return redirectPath || "/dashboard";
  };

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      phone: phone,
      phone_otp: "",
    },
    validationSchema: Yup.object({
      phone: Yup.string()
        .matches(/^[0-9]{10}$/, 'Please enter a valid 10-digit mobile number!')
        .required('Mobile number is required'),
      phone_otp: Yup.string().required("OTP is required"),
    }),
    onSubmit: async (values) => {
      // e.preventDefault();
      try {
        let submit1 = document.getElementById("submit1");
        submit1.disabled = true;
        submit1.textContent = "Processing...";

        // Add +91 prefix if not present (for API)
        const phoneForAPI = values.phone.startsWith('+') ? values.phone : `+91${values.phone}`;

        const jsonpar = JSON.stringify({
          phone: phoneForAPI,
          phone_otp: values.phone_otp,
        });
        
        const res = await postRequestWOAccessToken("auth/verify-phone", jsonpar);
        
        if (res && res.code === 200) {
          localStorage.setItem("popup", true);
          
          let tokenDetails = {
            guestMode: false,
            email: res.data.email,
            phone: res.data.phone,
            displayName: `${res.data.first_name} ${res.data.last_name}`,
            idToken: res.data.accesstoken,
            registered: true,
            refreshToken: res.data.refreshtoken,
            expiresIn: 3600,
          };
          
          dispatch(loadingToggleAction(true));

          // Get redirect path using priority system
          const redirectPath = getRedirectPath();

          // Dispatch login action with redirect
          dispatch(
            loginAction(tokenDetails, () => navigate(redirectPath), {
              code: 200,
              status: "success",
              message: "Login successful !",
            })
          );
        } else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: "error",
            message: res.message,
          }));
        }
      } catch (error) {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: "error",
          message: "An error occurred while verifying the user.",
        }));
      } finally {
        resetAlertData();

        let submit1 = document.getElementById('submit1');
        submit1.disabled = false;
        submit1.textContent = 'Submit';
      }
    },
  });


  const handleResendOTP = async () => {
    try {
      let submit2 = document.getElementById("submit2");
      submit2.disabled = true;
      submit2.classList.add("disabled-button");

      // Add +91 prefix if not present (for API)
      const phoneForAPI = phone.startsWith('+') ? phone : `+91${phone}`;

      const jsonpar = JSON.stringify({
        phone: phoneForAPI
      });
      
      const response = await postRequestWOAccessToken(`auth/resend-register-verification-otp-phone`, jsonpar);
      
      if (response.code === 200 && response.data) {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: "success",
          message: response.message
        }));
      } else {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: "error",
          message: response.message
        }));
      }
    } catch (error) {
      setAlertData({ variant: "error", message: "Something went wrong!" });
    } finally {
      resetAlertData();

      let submit2 = document.getElementById('submit2');
      submit2.disabled = false;
      submit2.classList.remove("disabled-button");
    }
  };

  React.useEffect(() => {
    if (location.state && typeof location.state.message !== "undefined") {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: 'OTP has been sent to your mobile number successfully.',
      }));
      resetAlertData();
    }
  }, []);

  return (
    <Grid2>
      {/* <Link className="skip" to="/">
        Skip <img src={rightArrow} alt="" />
      </Link> */}
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "calc(98vh - 33px)",
        }}
      >
        <Box
          sx={{
            width: 500,
            padding: 4,
            borderRadius: 2,
            backgroundColor: "#fff",
            textAlign: "center",
          }}
        >
          <Grid2 className="fullLogo">
            <div className="centerLogo">
              <img
                src={LogoIcon}
                alt="Logo"
                width={80}
                style={{ marginBottom: "10px" }}
              />
            </div>
            <div className="centerLogo">
              <img src={LogoText} alt="Logo" width={180} />
            </div>
          </Grid2>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            className="signin-title"
          >
            Verify Mobile Number
          </Typography>
          <form className="loginForm">
            <div className="position-relative password-field">
              <img
                src={mail}
                alt="Logo"
                width={24}
                className="textboxLefticon"
              />
              <TextField
                variant="outlined"
                fullWidth
                margin="normal"
                placeholder="Mobile Number"
                autoComplete="off"
                name="phone"
                type="number"
                className={`form-control ${
                  validation1.touched.phone && validation1.errors.phone
                    ? "is-invalid"
                    : ""
                }`}
                value={validation1.values.phone || ""}
                disabled={true}
                invalid={
                  validation1.touched.phone && validation1.errors.phone
                    ? true
                    : false
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end" style={{ marginRight: "0px" }}>
                        <img
                          className="password-hide-show"
                          src={edit}
                          onClick={ChangePhone}
                          alt="Edit"
                          width={24}
                          height={24}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {validation1.touched.phone && validation1.errors.phone ? (
                <div className="invalid-feedback">
                  {validation1.errors.phone}
                </div>
              ) : null}
            </div>
            <div className="position-relative fullName">
              <img
                src={passwordimg}
                alt="Logo"
                width={24}
                className="textboxLefticon textboxLefticon-password"
              />{" "}
              <TextField
                variant="outlined"
                fullWidth
                margin="normal"
                autoComplete="off"
                type="text"
                name="phone_otp"
                className={`form-control ${
                  validation1.touched.phone_otp && validation1.errors.phone_otp
                    ? "is-invalid"
                    : ""
                }`}
                placeholder="Enter OTP"
                value={validation1.values.phone_otp || ""}
                onChange={validation1.handleChange}
                onBlur={validation1.handleBlur}
                invalid={
                  validation1.touched.phone_otp && validation1.errors.phone_otp
                    ? true
                    : false
                }
              />
              {validation1.touched.phone_otp && validation1.errors.phone_otp ? (
                <div className="invalid-feedback">
                  {validation1.errors.phone_otp}
                </div>
              ) : null}
            </div>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ marginTop: 2, mb: 2 }}
              type="submit"
              id="submit1"
              className="btn-common btn bg-primary text-white btn-block"
              onClick={(e) => {
                e.preventDefault();
                validation1.handleSubmit();
                return false;
              }}
            >
              {"Submit"}
            </Button>
            <Typography
              className="Resend-code"
              id="submit2"
              onClick={(e) => {
                e.preventDefault();
                handleResendOTP();
              }}
              sx={{ cursor: 'pointer', textAlign: 'right', color: '#6638A2' }}
            >
              Didn't receive otp? Tap to resend
            </Typography>
          </form>
        </Box>
      </Box>
      <Typography className="dont">
        <Link to="/login">Back</Link>
      </Typography>
    </Grid2>
  );
};

export default VerifyPhone;
